// extracted by mini-css-extract-plugin
module.exports = {"list":"Dropdown_list___zF-e","item":"Dropdown_item__BRmBg","itemTitle":"Dropdown_itemTitle__7WWAI","itemIcon":"Dropdown_itemIcon__Yz6Yf"};